<div class="row animated fadeIn">
    <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/inquiry/inquirylist"><span
                        class="mdi mdi-arrow-left"></span></a> Add Inquiry</h4>
        </div>
        <div class="card" style="margin-bottom: 280px;">
            <div class="card-body">
                <div class="radio_container">
                    <input type="radio" name="radio" id="one" (change)="changeActivityType('activity')" checked>
                    <label for="one" class="mylabel" style="width:150px;">New Inquiry </label>
                    <input type="radio" name="radio" id="two" (change)="changeActivityType('generalActivity')">
                    <label for="two" class="mylabel" style="width:220px;">New Project & Inquiry </label>
                </div>

                <form [formGroup]="registerForm1" autocomplete="off">
                    <div class="form-row projectactivity mt-4" *ngIf="activitytype=='activity'">
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Project Name
                                (Project ID)<span class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="ProjectId" [data]="showProject"
                                [(ngModel)]="selectedproject" [settings]="dropdownSetting1"
                                (onSelect)="onProjectSelect($event)" (onDeSelect)="onProjectSelect($event)"
                                (onSelectAll)="onProjectSelect($event)" (onDeSelectAll)="onProjectSelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm1.get('ProjectId').invalid && registerForm1.get('ProjectId').errors && (registerForm1.get('ProjectId').dirty || registerForm1.get('ProjectId').touched) || submitted">
                                <small class="text-danger" *ngIf="registerForm1.get('ProjectId').hasError('required')">
                                    Project Name is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Inquiry Name
                                (Inquiry ID)<span class="required ml-1">*</span>
                            </label>
                            <mat-form-field appearance="fill" class="w-100">
                                <input type="text" placeholder="Inquiry Name" class="form-control example-no-focus py-0"
                                    aria-label="text" matInput [matAutocomplete]="auto" maxlength="100"
                                    formControlName="InquiryName" (input)="IqrSearchFun($event)">
                                <mat-autocomplete #auto="matAutocomplete" class="w-100">
                                    <mat-option *ngFor="let option of InqNameId | async" [value]="option">
                                        {{option}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <div
                                *ngIf="registerForm1.get('InquiryName').invalid && registerForm1.get('InquiryName').errors && (registerForm1.get('InquiryName').dirty || registerForm1.get('InquiryName').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm1.get('InquiryName').hasError('required')">
                                    Inquiry Name is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center"> Customer
                                Name<span class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="CustomerName" [data]="showCustomer"
                                [(ngModel)]="selectedcustomer" [settings]="dropdownSetting3"
                                (onSelect)="onCustomerSelect($event)" (onDeSelect)="onCustomerSelect($event)"
                                (onSelectAll)="onCustomerSelect($event)" (onDeSelectAll)="onCustomerSelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm1.get('CustomerName').invalid && registerForm1.get('CustomerName').errors && (registerForm1.get('CustomerName').dirty || registerForm1.get('CustomerName').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm1.get('CustomerName').hasError('required')">
                                    Customer Name is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Business
                                Vertical<span class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="BusinessVertical" [data]="businessVertical"
                                [(ngModel)]="selectedBusiness" [settings]="dropdownSetting12"
                                (onSelect)="onBusinessSelect($event)" (onDeSelect)="onBusinessSelect($event)"
                                (onSelectAll)="onBusinessSelect($event)" (onDeSelectAll)="onBusinessSelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm1.get('BusinessVertical').invalid && registerForm1.get('BusinessVertical').errors && (registerForm1.get('BusinessVertical').dirty || registerForm1.get('BusinessVertical').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm1.get('BusinessVertical').hasError('required')">
                                    Business Vertical is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Stages<span
                                    class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="StageId" [data]="showStage"
                                [(ngModel)]="selectedstage" [settings]="dropdownSetting8"
                                (onSelect)="onStageSelect($event)" (onDeSelect)="onStageSelect($event)"
                                (onSelectAll)="onStageSelect($event)" (onDeSelectAll)="onStageSelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm1.get('StageId').invalid && registerForm1.get('StageId').errors && (registerForm1.get('StageId').dirty || registerForm1.get('StageId').touched) || submitted">
                                <small class="text-danger" *ngIf="registerForm1.get('StageId').hasError('required')">
                                    Stage is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Inquiry
                                Probability<span class="required ml-1">*</span></label>
                            <angular2-multiselect formControlName="InquiryProbability" [data]="showProbability"
                                [(ngModel)]="selectedprobability" [settings]="dropdownSetting9"
                                (onSelect)="onProbabilitySelect($event)" (onDeSelect)="onProbabilitySelect($event)"
                                (onSelectAll)="onProbabilitySelect($event)"
                                (onDeSelectAll)="onProbabilitySelect($event)" fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm1.get('InquiryProbability').invalid && registerForm1.get('InquiryProbability').errors && (registerForm1.get('InquiryProbability').dirty || registerForm1.get('InquiryProbability').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm1.get('InquiryProbability').hasError('required')">
                                    Inquiry Probability is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center"> Received
                                Date<span class="required ml-1">*</span>
                            </label>
                            <div class="input-group">
                                <input type="text" class="bg-calender-icon form-control" id="inlineFormInputGroup"
                                    placeholder="DD-MM-YYYY" [minDate]="minDate" [maxDate]="maxDate" bsDatepicker
                                    formControlName="ReceivedDate" [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY'}"
                                    (keydown)="disableDate()" autocomplete="off">
                                <sapn class="position-absolute" *ngIf="registerForm1.get('ReceivedDate').value!=''"
                                    style="top: 50%; right: 5%; transform: translate(-50%, -50%);">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                        class="bi bi-x" viewBox="0 0 16 16" (click)="cleardate()">
                                        <path
                                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </sapn>
                            </div>
                            <div
                                *ngIf="registerForm1.get('ReceivedDate').invalid && registerForm1.get('ReceivedDate').errors && (registerForm1.get('ReceivedDate').dirty || registerForm1.get('ReceivedDate').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm1.get('ReceivedDate').hasError('required')">
                                    Received Date is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center"> Quotation
                                Engineer<span class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect [data]="showQuotationEr" formControlName="QuotationEngineerId"
                                [(ngModel)]="selectedquotationEr" [settings]="dropdownSetting10"
                                (onSelect)="onQuotationErSelect($event)" (onDeSelect)="onQuotationErSelect($event)"
                                (onSelectAll)="onQuotationErSelect($event)"
                                (onDeSelectAll)="onQuotationErSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm1.get('QuotationEngineerId').invalid && registerForm1.get('QuotationEngineerId').errors && (registerForm1.get('QuotationEngineerId').dirty || registerForm1.get('QuotationEngineerId').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm1.get('QuotationEngineerId').hasError('required')">
                                    Quotation Engineer is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center"> Sales
                                Engineer<span class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="SalesEngineerId" [data]="showSalesEr"
                                [(ngModel)]="selectedsalesEr" [settings]="dropdownSetting11"
                                (onSelect)="onSalesErSelect($event)" (onDeSelect)="onSalesErSelect($event)"
                                (onSelectAll)="onSalesErSelect($event)" (onDeSelectAll)="onSalesErSelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm1.get('SalesEngineerId').invalid && registerForm1.get('SalesEngineerId').errors && (registerForm1.get('SalesEngineerId').dirty || registerForm1.get('SalesEngineerId').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm1.get('SalesEngineerId').hasError('required')">
                                    Sales Engineer is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">MEP Contractor
                            </label>
                            <angular2-multiselect formControlName="MEPContractor" [data]="showContractor"
                                [(ngModel)]="selectedcontractor" [settings]="dropdownSetting4"
                                (onSelect)="onContractorSelect($event)" (onDeSelect)="onContractorSelect($event)"
                                (onSelectAll)="onContractorSelect($event)" (onDeSelectAll)="onContractorSelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Main Contractor
                            </label>
                            <angular2-multiselect formControlName="MainContractor" [data]="showMainContractor"
                                [(ngModel)]="selectedMaincontractor" [settings]="dropdownSetting5"
                                (onSelect)="onMainContractorSelect($event)"
                                (onDeSelect)="onMainContractorSelect($event)"
                                (onSelectAll)="onMainContractorSelect($event)"
                                (onDeSelectAll)="onMainContractorSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Design Consultant
                            </label>
                            <angular2-multiselect formControlName="DesignConsultant" [data]="showConsultant"
                                [(ngModel)]="selectedconsultant" [settings]="dropdownSetting6"
                                (onSelect)="onConsultantSelect($event)" (onDeSelect)="onConsultantSelect($event)"
                                (onSelectAll)="onConsultantSelect($event)" (onDeSelectAll)="onConsultantSelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Supervision
                                Consultant
                            </label>
                            <angular2-multiselect formControlName="SupervisionConsultant" [data]="showSupervision"
                                [(ngModel)]="selectedsupervision" [settings]="dropdownSetting7"
                                (onSelect)="onSupervisionSelect($event)" (onDeSelect)="onSupervisionSelect($event)"
                                (onSelectAll)="onSupervisionSelect($event)"
                                (onDeSelectAll)="onSupervisionSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="w-100"></div>
                        <div class="row mt-2">
                            <div class="col-lg-12">
                                <button href="javascript:void(0);" type="submit" class="btn btn-info mr-2"
                                    (click)="onSubmit('save')" [disabled]="isDisabled">Save</button>
                                <button href="javascript:void(0);" type="submit" [disabled]="isDisabled"
                                    class="btn btn-info bg-info border-info" (click)="onSubmit('product')">Save and Go
                                    Product</button>
                                <a href="javascript:void(0);" class="btn btn-danger ml-2"
                                    routerLink="/inquiry/inquirylist">Cancel</a>
                            </div>
                        </div>
                    </div>
                </form>

                <form [formGroup]="registerForm2" autocomplete="off">
                    <div class="form-row generalactivity mt-4" *ngIf="activitytype=='generalActivity'">
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Project
                                Name<span class="required ml-1">*</span>
                            </label>
                            <mat-form-field appearance="fill" class="w-100">
                                <input type="text" placeholder="Project Name" class="form-control example-no-focus py-0"
                                    aria-label="text" matInput [matAutocomplete]="auto" maxlength="100"
                                    formControlName="ProjectName" (input)="ProSearchFun($event)">
                                <mat-autocomplete #auto="matAutocomplete" class="w-100">
                                    <mat-option *ngFor="let option of ProNameId | async" [value]="option">
                                        {{option}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <div
                                *ngIf="registerForm2.get('ProjectName').invalid && registerForm2.get('ProjectName').errors && (registerForm2.get('ProjectName').dirty || registerForm2.get('ProjectName').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm2.get('ProjectName').hasError('required')">
                                    Project Name is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Project
                                Source<span class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="ProjectSource" [data]="showProjectSource"
                                [(ngModel)]="selectedprojectsource" [settings]="dropdownSetting16"
                                (onSelect)="onProjectSourceSelect($event)" (onDeSelect)="onProjectSourceSelect($event)"
                                (onSelectAll)="onProjectSourceSelect($event)"
                                (onDeSelectAll)="onProjectSourceSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm2.get('ProjectSource').invalid && registerForm2.get('ProjectSource').errors && (registerForm2.get('ProjectSource').dirty || registerForm2.get('ProjectSource').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm2.get('ProjectSource').hasError('required')">
                                    Project Source is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for=""
                                class="d-inline-block justify-content-between align-items-center">Territory<span
                                    class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="Territory" [data]="showTerritory"
                                [(ngModel)]="selectedterritory" [settings]="dropdownSetting17"
                                (onSelect)="onTerritorySelect($event)" (onDeSelect)="onTerritorySelect($event)"
                                (onSelectAll)="onTerritorySelect($event)" (onDeSelectAll)="onTerritorySelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm2.get('Territory').invalid && registerForm2.get('Territory').errors && (registerForm2.get('Territory').dirty || registerForm2.get('Territory').touched) || submitted">
                                <small class="text-danger" *ngIf="registerForm2.get('Territory').hasError('required')">
                                    Territory is Required.
                                </small>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Inquiry
                                Name<span class="required ml-1">*</span>
                            </label>
                            <input class="form-control" type="text" formControlName="InquiryName"
                                (input)="NameSpaceNotAllowed($event)" maxlength="100" />
                            <div
                                *ngIf="registerForm2.get('InquiryName').invalid && registerForm2.get('InquiryName').errors && (registerForm2.get('InquiryName').dirty || registerForm2.get('InquiryName').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm2.get('InquiryName').hasError('required')">
                                    Inquiry Name is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center"> Customer
                                Name<span class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="CustomerName" [data]="showCustomer"
                                [(ngModel)]="selectedcustomer2" [settings]="dropdownSetting3"
                                (onSelect)="onCustomerSelect2($event)" (onDeSelect)="onCustomerSelect2($event)"
                                (onSelectAll)="onCustomerSelect2($event)" (onDeSelectAll)="onCustomerSelect2($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm2.get('CustomerName').invalid && registerForm2.get('CustomerName').errors && (registerForm2.get('CustomerName').dirty || registerForm2.get('CustomerName').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm2.get('CustomerName').hasError('required')">
                                    Customer Name is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12 multiselect-250-height">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Business
                                Vertical<span class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="BusinessVertical" [data]="businessVertical"
                                [(ngModel)]="selectedBusiness2" [settings]="dropdownSetting12"
                                (onSelect)="onBusinessSelect2($event)" (onDeSelect)="onBusinessSelect2($event)"
                                (onSelectAll)="onBusinessSelect2($event)" (onDeSelectAll)="onBusinessSelect2($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm2.get('BusinessVertical').invalid && registerForm2.get('BusinessVertical').errors && (registerForm2.get('BusinessVertical').dirty || registerForm2.get('BusinessVertical').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm2.get('BusinessVertical').hasError('required')">
                                    Business Vertical is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Stages<span
                                    class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="StageId" [data]="showStage"
                                [(ngModel)]="selectedstage2" [settings]="dropdownSetting8"
                                (onSelect)="onStageSelect2($event)" (onDeSelect)="onStageSelect2($event)"
                                (onSelectAll)="onStageSelect2($event)" (onDeSelectAll)="onStageSelect2($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm2.get('StageId').invalid && registerForm2.get('StageId').errors && (registerForm2.get('StageId').dirty || registerForm2.get('StageId').touched) || submitted">
                                <small class="text-danger" *ngIf="registerForm2.get('StageId').hasError('required')">
                                    Stage is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center">Inquiry
                                Probability<span class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="InquiryProbability" [data]="showProbability"
                                [(ngModel)]="selectedprobability2" [settings]="dropdownSetting9"
                                (onSelect)="onProbabilitySelect2($event)" (onDeSelect)="onProbabilitySelect2($event)"
                                (onSelectAll)="onProbabilitySelect2($event)"
                                (onDeSelectAll)="onProbabilitySelect2($event)" fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm2.get('InquiryProbability').invalid && registerForm2.get('InquiryProbability').errors && (registerForm2.get('InquiryProbability').dirty || registerForm2.get('InquiryProbability').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm2.get('InquiryProbability').hasError('required')">
                                    Inquiry Probability is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-inline-block justify-content-between align-items-center"> Received
                                Date<span class="required ml-1">*</span>
                            </label>
                            <div class="input-group">
                                <input type="text" class="bg-calender-icon form-control" id="inlineFormInputGroup"
                                    placeholder="DD/MM/YYYY" [minDate]="minDate" [maxDate]="maxDate" bsDatepicker
                                    formControlName="ReceivedDate2" [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY'}"
                                    (keydown)="disableDate()" autocomplete="off">
                                <sapn class="position-absolute" *ngIf="registerForm2.get('ReceivedDate2').value!=''"
                                    style="top: 50%; right: 5%; transform: translate(-50%, -50%);">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                        class="bi bi-x" viewBox="0 0 16 16" (click)="cleardate2()">
                                        <path
                                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </sapn>
                            </div>
                            <div
                                *ngIf="registerForm2.get('ReceivedDate2').invalid && registerForm2.get('ReceivedDate2').errors && (registerForm2.get('ReceivedDate2').dirty || registerForm2.get('ReceivedDate2').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm2.get('ReceivedDate2').hasError('required')">
                                    Received Date is Required.
                                </small>
                            </div>
                        </div>

                        <div class="form-group col-lg-3 col-md-6 col-sm-12 multiselect-250-height">
                            <label for="" class="d-inline-block justify-content-between align-items-center"> Quotation
                                Engineer<span class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="QuotationEngineerId" [data]="showQuotationEr"
                                [(ngModel)]="selectedquotationEr2" [settings]="dropdownSetting10"
                                (onSelect)="onQuotationErSelect2($event)" (onDeSelect)="onQuotationErSelect2($event)"
                                (onSelectAll)="onQuotationErSelect2($event)"
                                (onDeSelectAll)="onQuotationErSelect2($event)" fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm2.get('QuotationEngineerId').invalid && registerForm2.get('QuotationEngineerId').errors && (registerForm2.get('QuotationEngineerId').dirty || registerForm2.get('QuotationEngineerId').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm2.get('QuotationEngineerId').hasError('required')">
                                    Quotation Engineer is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12 multiselect-250-height">
                            <label for="" class="d-inline-block justify-content-between align-items-center"> Sales
                                Engineer<span class="required ml-1">*</span>
                            </label>
                            <angular2-multiselect formControlName="SalesEngineerId" [data]="showSalesEr"
                                [(ngModel)]="selectedsalesEr2" [settings]="dropdownSetting11"
                                (onSelect)="onSalesErSelect2($event)" (onDeSelect)="onSalesErSelect2($event)"
                                (onSelectAll)="onSalesErSelect2($event)" (onDeSelectAll)="onSalesErSelect2($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                            <div
                                *ngIf="registerForm2.get('SalesEngineerId').invalid && registerForm2.get('SalesEngineerId').errors && (registerForm2.get('SalesEngineerId').dirty || registerForm2.get('SalesEngineerId').touched) || submitted">
                                <small class="text-danger"
                                    *ngIf="registerForm2.get('SalesEngineerId').hasError('required')">
                                    Sales Engineer is Required.
                                </small>
                            </div>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12 mb-0">
                            <label for="" class="d-flex justify-content-between align-items-center">MEP Contractor
                            </label>
                            <angular2-multiselect formControlName="MEPContractor" [data]="showContractor"
                                [(ngModel)]="selectedcontractor2" [settings]="dropdownSetting4"
                                (onSelect)="onContractorSelect2($event)" (onDeSelect)="onContractorSelect2($event)"
                                (onSelectAll)="onContractorSelect2($event)"
                                (onDeSelectAll)="onContractorSelect2($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Main Contractor
                            </label>
                            <angular2-multiselect formControlName="MainContractor" [data]="showMainContractor"
                                [(ngModel)]="selectedMaincontractor2" [settings]="dropdownSetting5"
                                (onSelect)="onMainContractorSelect2($event)"
                                (onDeSelect)="onMainContractorSelect2($event)"
                                (onSelectAll)="onMainContractorSelect2($event)"
                                (onDeSelectAll)="onMainContractorSelect2($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Design Consultant
                            </label>
                            <angular2-multiselect formControlName="DesignConsultant" [data]="showConsultant"
                                [(ngModel)]="selectedconsultant2" [settings]="dropdownSetting6"
                                (onSelect)="onConsultantSelect2($event)" (onDeSelect)="onConsultantSelect2($event)"
                                (onSelectAll)="onConsultantSelect2($event)"
                                (onDeSelectAll)="onConsultantSelect2($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="form-group col-lg-3 col-md-6 col-sm-12">
                            <label for="" class="d-flex justify-content-between align-items-center">Supervision
                                Consultant
                            </label>
                            <angular2-multiselect formControlName="SupervisionConsultant" [data]="showSupervision"
                                [(ngModel)]="selectedsupervision2" [settings]="dropdownSetting7"
                                (onSelect)="onSupervisionSelect2($event)" (onDeSelect)="onSupervisionSelect2($event)"
                                (onSelectAll)="onSupervisionSelect2($event)"
                                (onDeSelectAll)="onSupervisionSelect2($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>

                        <div class="w-100"></div>

                        <div class="row mt-1">
                            <div class="col-lg-12">
                                <button href="javascript:void(0);" type="submit" class="btn btn-info mr-2"
                                    (click)="onSubmit('save')">Save</button>
                                <button href="javascript:void(0);" type="submit"
                                    class="btn btn-info bg-info ml-2 border-info ml-2"
                                    (click)="onSubmit('product')">Save
                                    and Go Product</button>
                                <a href="javascript:void(0);" class="btn btn-danger ml-2"
                                    routerLink="/inquiry/inquirylist">Cancel</a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>